import { useEffect, useState, useCallback } from 'react'

const useToggleHandler = node => {
    const [open, setOpen] = useState(false)
    const toggle = () => setOpen(!open)

    const handleClickOutside = useCallback(
        e => {
            if (node.current?.contains(e.target)) return

            setOpen(false)
        },

        [node]
    )

    const handleKeyPress = e => {
        if (e.key === 'Escape') setOpen(false)
    }

    useEffect(() => {
        if (open) {
            document.addEventListener('mousedown', handleClickOutside)
            document.addEventListener('keydown', handleKeyPress)
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
            document.removeEventListener('keydown', handleKeyPress)
        }
    }, [open])

    return { open, setOpen, toggle }
}

export default useToggleHandler
